export const ABOUT_US = 'ABOUT_US';
export const ACCOUNT_ACTION_CHOOSER = 'ACCOUNT_ACTION_CHOOSER';
export const ACCOUNT_COLLECT_MISSING_DETAILS = 'ACCOUNT_COLLECT_MISSING_DETAILS';
export const BRAND_NAME = 'BRAND_NAME';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const ACCOUNT_REWARDS = 'ACCOUNT_REWARDS';
export const ACCOUNT_COMMUNICATIONS_PREFERENCES = 'ACCOUNT_COMMUNICATIONS_PREFERENCES';
export const CONTACT_US = 'CONTACT_US';
export const CONTACT_US_SUBMIT_TICKET = 'CONTACT_US_SUBMIT_TICKET';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_INFO = 'DELETE_ACCOUNT_INFO';
export const DELIVERY_AND_PICKUP_FAQS = 'DELIVERY_AND_PICKUP_FAQS';
export const DEPARTMENT_NAME = 'DEPARTMENT_NAME';
export const SHOP_ALL_NAME = 'SHOP_ALL_NAME';
export const DISCOVER_FILTER = 'DISCOVER_FILTER';
export const MEMBERS_PRICE_LIST = 'MEMBERS_PRICE_LIST';
export const EXCLUSIVE_OFFER_LIST = 'EXCLUSIVE_OFFER_LIST';
export const REWARDS_FILTER = 'REWARDS_FILTER';
export const DISCOVER_NAME = 'DISCOVER_NAME';
export const DISCOVER_SEGMENT = 'DISCOVER_SEGMENT';
export const DRAWER_NAME = 'DRAWER_NAME';
export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const FAVOURITE_BRANDS = 'FAVOURITE_BRANDS';
export const FEED_SEGMENT = 'FEED_SEGMENT';
export const FILTER_MFL = 'FILTER_MFL';
export const FILTER_SEGMENT = 'FILTER_SEGMENT';
export const GIFT_CARDS_HOW_TO_CHECK_BALANCE = 'GIFT_CARDS_HOW_TO_CHECK_BALANCE';
export const GIFT_CARDS_HOW_TO_REDEEM = 'GIFT_CARDS_HOW_TO_REDEEM';
export const GIFT_CARDS_OPTIONS = 'GIFT_CARDS_OPTIONS';
export const GIFT_CARDS_STORE_ORDER_REVIEW = 'GIFT_CARDS_STORE_ORDER_REVIEW';
export const GIFT_CARDS_TERMS_AND_CONDITIONS = 'GIFT_CARDS_TERMS_AND_CONDITIONS';
export const INFORMATION = 'INFORMATION';
export const INFORMATION_CONTENT = 'INFORMATION_CONTENT';
export const LOGIN = 'LOGIN';
export const LOGIN_ENTRY = 'LOGIN_ENTRY';
export const NEW_ACCOUNT = 'NEW_ACCOUNT';
export const ORDER_COMPETITIONS = 'ORDER_COMPETITIONS';
export const ORDER_CONFIRMATION = 'ORDER_CONFIRMATION';
export const ORDER_SCREEN = 'ORDER_SCREEN';
export const PAYMENT_METHOD = 'PAYMENT_METHOD';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const PROCESSING_ORDER = 'PROCESSING_ORDER';
export const PROMOTION_NAME = 'PROMOTION_NAME';
export const PROMOTIONS_CURRENT = 'PROMOTIONS_CURRENT';
export const PROMOTIONS_MAIN = 'PROMOTIONS_MAIN';
export const PROMOTIONS_WINNERS = 'PROMOTIONS_WINNERS';

export const EXCLUSIVE_OFFER_NAME = 'EXCLUSIVE_OFFER_NAME';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESPONSIBLE_SERVICE = 'RESPONSIBLE_SERVICE';
export const RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS =
  'RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS';
export const RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST = 'RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST';
export const RETURNS_AND_EXCHANGES = 'RETURNS_AND_EXCHANGES';
export const SEARCH = 'SEARCH';
export const SELF_EXCLUSION = 'SELF_EXCLUSION';
export const STORE_DETAILS = 'STORE_DETAILS';
export const STORE_NAME = 'STORE_NAME';
/**
 * Show store name as a card. Used on cart pages
 */
export const STORE_NAME_CARD = 'STORE_NAME_CARD';
/**
 * Just show store name and back button. This is for checkout uplift
 */
export const STORE_NAME_CHECKOUT = 'STORE_NAME_CHECKOUT';
export const STORE_SELECTION = 'STORE_SELECTION';
export const STORE_SELECTION_SWITCH = 'STORE_SELECTION_SWITCH';
export const SUB_DEPARTMENT_NAME = 'SUB_DEPARTMENT_NAME';
export const SUBURB_SELECTION = 'SUBURB_SELECTION';
export const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
export const VIEW_ORDER = 'VIEW_ORDER';

export const REWARDS_SIGN_IN = 'REWARDS_SIGN_IN';
export const REWARDS_SIGN_UP = 'REWARDS_SIGN_UP';
export const REWARDS_VERIFICATION = 'REWARDS_VERIFICATION';
export const REWARDS_SUCCESS = 'REWARDS_SUCCESS';
export const REWARDS_TERMS_AND_CONDITIONS = 'REWARDS_TERMS_AND_CONDITIONS';
